import { useState } from "react";
import "./Reports.css";
import axios from "axios";

function Reports({ products }) {
  const [report, setReport] = useState({
    fromdate: "",
    todate: "",
    product: "",
    review: "",
    reportdata: [],
    isreportopen: false,
  });

  const handleSearch = async () => {
    if (
      report?.fromdate ||
      report?.todate ||
      report?.product ||
      report?.review
    ) {
      if (!report.fromdate || !report.todate) {
        alert("⚠️ Please select both From Date and To Date.");
        return;
      }

      const from = new Date(report.fromdate);
      const to = new Date(report.todate);

      if (to < from) {
        alert("❌ To Date cannot be earlier than From Date.");
        return;
      }
      const formData = new FormData();
      formData.append("start_date", report.fromdate || "");
      formData.append("end_date", report.todate || "");
      formData.append("product_id", report.product || "");
      formData.append("rating", report.review || "");
      formData.append("vendor_id", "1");

      try {
        const res = await axios.post(
          `${process.env.REACT_APP_BASEURL}/apis/vendor/report.php`,
          formData
        );
        const data = res.data?.data || res.data;
        if (Array.isArray(data)) {
          setReport((pv) => ({ ...pv, reportdata: data, isreportopen: true }));
        } else {
          setReport((prev) => ({
            ...prev,
            reportdata: [],
          }));
          console.warn("No valid data received", res.data);
        }
      } catch (err) {
        console.error("Error fetching report", err);
      }
    } else {
      alert("📝 Please apply a filter to generate the report.");
    }
  };

  const handledownload = async () => {
    const params = new URLSearchParams({
      start_date: report.fromdate || "",
      end_date: report.todate || "",
      product_id: report.product || "",
      rating: report.review || "",
      vendor_id: "1",
    });

    try {
      const response = await fetch(
        `${
          process.env.REACT_APP_BASEURL
        }/apis/vendor/report_down.php?${params.toString()}`,
        {
          method: "GET",
        }
      );

      if (!response.ok) throw new Error("Failed to fetch file");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "report.pdf";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
      alert("Failed to download report.");
    }
  };

  return (
    <div>
      <h1 className="dashboard-heading">Reports</h1>

      <div className="report-page">
        <div className="filters">
          <div className="filter-group">
            <label>From Date</label>
            <input
              type="date"
              value={report?.fromdate || ""}
              max={new Date().toISOString().split("T")[0]}
              onChange={(e) =>
                setReport((prev) => ({ ...prev, fromdate: e.target.value }))
              }
            />
          </div>

          <div className="filter-group">
            <label>To Date</label>
            <input
              type="date"
              value={report?.todate || ""}
              max={new Date().toISOString().split("T")[0]}
              onChange={(e) =>
                setReport((prev) => ({ ...prev, todate: e.target.value }))
              }
            />
          </div>

          <div className="filter-group">
            <label>Product</label>
            <select
              value={report?.product || ""}
              onChange={(e) =>
                setReport((pv) => ({ ...pv, product: e.target.value }))
              }
            >
              <option value="">-- Select Product --</option>
              {products.map((item) => (
                <option key={item.product_id} value={item.product_id}>{item.prod_name}</option>
              ))}
            </select>
          </div>

          <div className="filter-group">
            <label>Review</label>
            <select
              value={report?.review || ""}
              onChange={(e) =>
                setReport((pv) => ({ ...pv, review: e.target.value }))
              }
            >
              <option value="">-- Select Review --</option>
              <option value="5">5 Star</option>
              <option value="4">4 Star</option>
              <option value="3">3 Star</option>
              <option value="2">2 Star</option>
              <option value="1">1 Star</option>
            </select>
          </div>
        </div>

        {/* Centered Search Button */}
        <div className="filter-button-wrapper">
          <button className="search-btn" onClick={handleSearch}>
            Search
          </button>
        </div>
        {report?.reportdata.length > 0 && (
          <button className="download-btn" onClick={handledownload}>
            Download
          </button>
        )}
      </div>

      {report?.isreportopen && (
        <>
          {" "}
          {report?.reportdata.length > 0 ? (
            <>
              <table className="report-table">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Date</th>
                    <th>Product Name</th>
                    <th>Customer Name</th>
                    <th>Price</th>
                    <th>Qty</th>
                    <th>Total Amt</th>
                    <th>Rating</th>
                  </tr>
                </thead>
                <tbody>
                  {report?.reportdata.map((item, i) => (
                    <tr key={i}>
                      <td>{i + 1}</td>
                      <td>{item?.order_date}</td>
                      <td>
                        {item?.prodtuct_id}-{item?.prod_name}
                      </td>
                      <td>{item?.customer_name}</td>
                      <td>{item?.price}</td>
                      <td>{item?.quantity}</td>
                      <td>{item?.total_amount}</td>
                      <td>{item?.rating}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          ) : (
            <div className="no-data-message">
              <p>No data found for the selected filters.</p>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default Reports;
